import React, { Component } from 'react';
import './App.css';
import { makeRequest } from './Helpers';
import Sidebar from './components/Sidebar';
import JokesContainer from './components/JokesContainer';

class App extends Component {
  state = {
    jokes: [],
    loading: false
  };

  async componentDidMount() {
    this.setState({ loading: true });

    if (localStorage.getItem('jokes')) {
      const jokes = localStorage.getItem('jokes');
      this.setState({ jokes: JSON.parse(jokes), loading: false });
      return;
    }

    const jokes = [];

    let i = 0;

    while (i <= 10) {
      const request = makeRequest('https://icanhazdadjoke.com/');
      await request.then(data => {
        jokes.push({ ...data, score: 0 });
      });
      i++;
    }

    localStorage.setItem('jokes', JSON.stringify(jokes));

    this.setState({ jokes, loading: false });
  }

  loading = bool => {
    this.setState({ loading: bool });
  };

  reloadJokes = data => {
    this.setState({ jokes: data, loading: false });
  };

  setScore = (id, score) => {
    this.setState(st => {
      const scored = st.jokes.map(joke => {
        if (joke.id === id) {
          joke.score = score;
          return joke;
        }
        return joke;
      });

      localStorage.setItem('jokes', JSON.stringify(scored));
      return { jokes: scored };
    });
  };

  render() {
    const sorted = this.state.jokes.sort((a, b) => {
      return b.score - a.score;
    });

    return (
      <div className="App">
        <Sidebar reloadJokes={this.reloadJokes} loading={this.loading} />

        <JokesContainer
          jokes={sorted}
          loading={this.state.loading}
          setScore={this.setScore}
        />
      </div>
    );
  }
}

export default App;
